var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-inline-flex mb-4" }, [
        _vm.lightsFields && _vm.lightsFields.length
          ? _c("div", { staticClass: "form-check mr-3" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectAll,
                    expression: "selectAll"
                  }
                ],
                staticClass: "check form-check-input select-all mt-0",
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.selectAll)
                    ? _vm._i(_vm.selectAll, null) > -1
                    : _vm.selectAll
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.selectAll,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.selectAll = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.selectAll = $$c
                    }
                  }
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("h4", { staticClass: "mr-3 mb-0" }, [_vm._v("Lights ")]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c(
            "span",
            {
              staticClass: "cursor-pointer",
              on: {
                click: function($event) {
                  return _vm.addNewLight()
                }
              }
            },
            [
              _c("img", {
                staticClass: "heading-icon",
                attrs: {
                  src: require("@/assets/addplus_icon.svg"),
                  width: "20"
                }
              })
            ]
          ),
          _vm._v(" "),
          _vm.isSelected
            ? _c(
                "span",
                {
                  staticClass: "cursor-pointer ml-3",
                  on: {
                    click: function($event) {
                      return _vm.deleteAllLights()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-trash" })]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.lightsFields, function(item, index) {
        return _c("div", { key: index, staticClass: "mb-5" }, [
          _c(
            "div",
            { staticClass: "fields-wrapper is-divider is-multi-node mb-3" },
            [
              _c("div", { staticClass: "form-check select-single" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: item.light.selectSingle,
                      expression: "item.light.selectSingle"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(item.light.selectSingle)
                      ? _vm._i(item.light.selectSingle, null) > -1
                      : item.light.selectSingle
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = item.light.selectSingle,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                item.light,
                                "selectSingle",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                item.light,
                                "selectSingle",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(item.light, "selectSingle", $$c)
                        }
                      },
                      _vm.checkSingleSelect
                    ]
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "action-buttons" }, [
                _c(
                  "span",
                  {
                    staticClass: "action-item ",
                    on: {
                      click: function($event) {
                        return _vm.copyLight(index, item)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-copy" })]
                ),
                _vm._v(" "),
                item.light.selectSingle
                  ? _c(
                      "span",
                      {
                        staticClass: "action-item",
                        on: {
                          click: function($event) {
                            return _vm.deleteLight(index)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-trash" })]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-6" }, [
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                        _vm._v("\n              Select light\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-8" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.light.lightType,
                                expression: "item.light.lightType"
                              }
                            ],
                            staticClass: "custom-select",
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    item.light,
                                    "lightType",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  return _vm.lightTypeChanged(index)
                                }
                              ]
                            }
                          },
                          [
                            _c("option", { attrs: { value: "point" } }, [
                              _vm._v("Point Light")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "spot" } }, [
                              _vm._v("Spot Light")
                            ])
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-4 col-form-label",
                          attrs: { for: "start_time" }
                        },
                        [_vm._v("\n              Start Time\n            ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-8" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.light.startTime,
                              expression: "item.light.startTime"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "mumber", id: "start_time" },
                          domProps: { value: item.light.startTime },
                          on: {
                            change: function($event) {
                              return _vm.setDuration(index)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                item.light,
                                "startTime",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-4 col-form-label",
                          attrs: { for: "start_time" }
                        },
                        [_vm._v("\n              End Time\n            ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-8" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.light.endTime,
                              expression: "item.light.endTime"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number", id: "end_time" },
                          domProps: { value: item.light.endTime },
                          on: {
                            change: function($event) {
                              return _vm.setDuration(index)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                item.light,
                                "endTime",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                        _vm._v("\n              Duration\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-8" }, [
                        _c("input", {
                          staticClass: "form-control",
                          attrs: {
                            type: "number",
                            id: "light_duration_e",
                            readonly: ""
                          },
                          domProps: {
                            value: (
                              item.light.endTime - item.light.startTime
                            ).toFixed(2)
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-4 col-form-label",
                          attrs: { for: "range" }
                        },
                        [_vm._v("\n              Range\n            ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-8" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.light.range,
                              expression: "item.light.range"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number", id: "range" },
                          domProps: { value: item.light.range },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(item.light, "range", $event.target.value)
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-4 col-form-label",
                          attrs: { for: "exposure" }
                        },
                        [_vm._v("\n              Exposure\n            ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-8" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.light.exposure,
                              expression: "item.light.exposure"
                            }
                          ],
                          attrs: { type: "range", min: "0", max: "2" },
                          domProps: { value: item.light.exposure },
                          on: {
                            __r: function($event) {
                              return _vm.$set(
                                item.light,
                                "exposure",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-3" }, [
                          _vm._v(_vm._s(item.light.exposure))
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  item.light.lightType == "spot"
                    ? _c(
                        "div",
                        { staticClass: "row form-group align-items-center" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "col-sm-4 col-form-label",
                              attrs: { for: "spotAngle" }
                            },
                            [_vm._v("\n              Spot Angle\n            ")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-sm-8" }, [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c("span", { staticClass: "p-2" }, [
                                  _vm._v("Inner")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.light.innerSpotAngle,
                                      expression: "item.light.innerSpotAngle"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    max: "360",
                                    id: "innerangle"
                                  },
                                  domProps: {
                                    value: item.light.innerSpotAngle
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        item.light,
                                        "innerSpotAngle",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "p-2" }, [
                                  _vm._v("Outer")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.light.outerSpotAngle,
                                      expression: "item.light.outerSpotAngle"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    min: "0",
                                    max: "360",
                                    id: "outerangle"
                                  },
                                  domProps: {
                                    value: item.light.outerSpotAngle
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        item.light,
                                        "outerSpotAngle",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6" }, [
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-4 col-form-label",
                          attrs: { id: "color" }
                        },
                        [_vm._v("\n              Color\n            ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-8" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.light.color,
                              expression: "item.light.color"
                            }
                          ],
                          attrs: {
                            type: "color",
                            id: "favcolor",
                            name: "favcolor"
                          },
                          domProps: { value: item.light.color },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(item.light, "color", $event.target.value)
                            }
                          }
                        }),
                        _vm._v(
                          "\n\n              " +
                            _vm._s(item.light.color) +
                            "\n\n            "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                        _vm._v("\n              Shadow Type\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-8" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.light.shadowType,
                                expression: "item.light.shadowType"
                              }
                            ],
                            staticClass: "custom-select",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  item.light,
                                  "shadowType",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "Soft" } }, [
                              _vm._v("Soft")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "Hard" } }, [
                              _vm._v("Hard")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "None" } }, [
                              _vm._v("None")
                            ])
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                        _vm._v("\n              Shadow Strength\n            ")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-8" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.light.shadowStrength,
                              expression: "item.light.shadowStrength"
                            }
                          ],
                          attrs: {
                            type: "range",
                            min: "0",
                            max: "1",
                            step: "0.1"
                          },
                          domProps: { value: item.light.shadowStrength },
                          on: {
                            __r: function($event) {
                              return _vm.$set(
                                item.light,
                                "shadowStrength",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-3" }, [
                          _vm._v(_vm._s(item.light.shadowStrength))
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-4 col-form-label",
                          attrs: { for: "mode" }
                        },
                        [_vm._v("\n              Mode\n            ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-8" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: item.light.lightMode,
                                expression: "item.light.lightMode"
                              }
                            ],
                            staticClass: "custom-select",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  item.light,
                                  "lightMode",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "Realtime" } }, [
                              _vm._v("Realtime")
                            ])
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                        _vm._v(
                          "\n              Position of the origin\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-8" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.light.localPosition[0],
                                  expression: "item.light.localPosition[0]"
                                }
                              ],
                              staticClass: "form-control border-danger",
                              attrs: {
                                type: "number",
                                id: "position_of_the_origin_x"
                              },
                              domProps: { value: item.light.localPosition[0] },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    item.light.localPosition,
                                    0,
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.light.localPosition[1],
                                  expression: "item.light.localPosition[1]"
                                }
                              ],
                              staticClass: "form-control border-success",
                              attrs: {
                                type: "number",
                                id: "position_of_the_origin_y"
                              },
                              domProps: { value: item.light.localPosition[1] },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    item.light.localPosition,
                                    1,
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.light.localPosition[2],
                                  expression: "item.light.localPosition[2]"
                                }
                              ],
                              staticClass: "form-control border-secondary",
                              attrs: {
                                type: "number",
                                id: "position_of_the_origin_z"
                              },
                              domProps: { value: item.light.localPosition[2] },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    item.light.localPosition,
                                    2,
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row form-group align-items-center" },
                    [
                      _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                        _vm._v(
                          "\n              Rotation of the origin\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-8" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.light.localRotation[0],
                                  expression: "item.light.localRotation[0]"
                                }
                              ],
                              staticClass: "form-control border-danger",
                              attrs: {
                                type: "number",
                                id: "rotation_of_the_origin_x"
                              },
                              domProps: { value: item.light.localRotation[0] },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    item.light.localRotation,
                                    0,
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.light.localRotation[1],
                                  expression: "item.light.localRotation[1]"
                                }
                              ],
                              staticClass: "form-control border-success",
                              attrs: {
                                type: "number",
                                id: "rotation_of_the_origin_y"
                              },
                              domProps: { value: item.light.localRotation[1] },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    item.light.localRotation,
                                    1,
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.light.localRotation[2],
                                  expression: "item.light.localRotation[2]"
                                }
                              ],
                              staticClass: "form-control border-secondary",
                              attrs: {
                                type: "number",
                                id: "rotation_of_the_origin_z"
                              },
                              domProps: { value: item.light.localRotation[2] },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    item.light.localRotation,
                                    2,
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-645a4b9f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-645a4b9f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-components/character/light.vue
// module id = null
// module chunks = 